// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {Typography} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import {colors} from '../../../../../assets/styles/colors';

import CustomModal from '../../../../../elements/CustomModal/CustomModal';

import type {RootState} from '../../../..';
import {bindActionCreators} from 'redux';
import type {Dispatch} from 'redux';
import {actions as UiActions} from '../../../../ui/duck';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    noUserPermissionsModalOpen: state.ui.noUserPermissionsModalOpen,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...UiActions,
      },
      dispatch
    )
)(NoUserPermissionsModal);

type Props = {
  noUserPermissionsModalOpen?: boolean,
  openNoUserPermissionsModal: () => void,
  closeNoUserPermissionsModal: () => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // width: 420,
    maxWidth: '100%',
    padding: theme.spacing(3, 0),
  },
  text: {
    textAlign: 'center',
    fontSize: '1.125rem',
    // marginTop: theme.spacing(2),
    color: colors.grey800,
    // [theme.breakpoints.down('sm')]: {
    //   marginBottom: theme.spacing(2),
    //   fontSize: '1rem',
    // },
  },
  button: {
    height: 48,
    marginTop: theme.spacing(3),
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '4px 80px',
    maxWidth: '100%',
  },
}));

function NoUserPermissionsModal(props: Props) {
  const {
    noUserPermissionsModalOpen,
    // openNoUserPermissionsModal,
    closeNoUserPermissionsModal,
  } = props;
  const classes = useStyles();

  return (
    <CustomModal
      open={noUserPermissionsModalOpen}
      handleCloseModal={closeNoUserPermissionsModal}
    >
      <div className={classes.root}>
        <Typography className={classes.text}>
          Tu perfil no tiene permisos para acceder a esta funcionalidad.
        </Typography>
      </div>
    </CustomModal>
  );
}

NoUserPermissionsModal.propTypes = {
  noUserPermissionsModalOpen: PropTypes.bool,
  openNoUserPermissionsModal: PropTypes.func.isRequired,
  closeNoUserPermissionsModal: PropTypes.func.isRequired,
};
